import { Api } from 'lib';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { EntitySettings, IrreversableModal } from 'screens/Admin/components';

const Settings = ({ product, closeModal }) => {
  const [visible, setVisible] = useState(null),
    [loading, setLoading] = useState(false),
    dispatch = useDispatch();

  async function handleRemove() {
    setLoading(true);

    const res = await Api.post('/admin/hideProduct', { productId: product._id });

    setLoading(false);
    if (!res) return;

    closeModal();
  }

  if (!product) return null;

  const settings = [
    {
      text: 'Remove product',
      icon: 'delete',
      onClick: () => setVisible('remove'),
      isDisabled: loading
    }
  ];

  return (
    <React.Fragment>
      <EntitySettings options={settings} />

      <IrreversableModal
        visible={visible === 'remove'}
        heading="You are about to remove this product."
        onConfirm={handleRemove}
        closeModal={() => setVisible(null)}
      />
    </React.Fragment>
  );
};

export default Settings;
